const APP_CONFIG = {
  version: "7.91.0",
  title: "Claire V7.91.0",
  version_client: "7.91.0",
};

export default APP_CONFIG;
